import React, { Fragment } from 'react'
import logo from '../../Image/صيّن-removebg-preview.png'
import './NavBar.css'
import { Link } from 'react-router-dom'

function NavBar1() {
  return (
    <Fragment>
        <nav>
              <div className='nav_img' >
                <img src={logo} />
              </div>
            <ul>
              <li><Link to='/'>الرئيسيه</Link></li>
              <li><Link to='/الخدمات'>الخدمات</Link></li>
              <li><Link to="/فني">اطلب فني</Link></li>
              {/* <li><a href='#'>Pricing</a></li> */}
              {/* <button className='btn1'>Try Whitpace free</button> */}
            </ul>
        </nav>
    </Fragment>
    
  )
}

export default NavBar1
